import React, { useEffect, useState } from 'react'
import styles from './BillingData.module.css'
import Text from '../../../components/text/Text'
import arrowBack from '../../../assets/icons/icons-arrow-back.svg'
import { useNavigate } from 'react-router-dom'
import routes from '../../../router/routes'
import SvgIcon from '../../../components/svgIcon/SvgIcon'
import { getInvoiceData } from '../../../services/billing'
import { format } from 'date-fns'
import { formatRut } from '../../../formatters'

export function BillingData() {
    const navigation = useNavigate()

    const [data, setData] = useState({
        rut: '',
        correo: '',
        nombre: '',
        commission: {
            presencial: '',
            online: '',
            avance: '',
        },
        giro: '',
        recurrencia: '',
        fecha_contrato: '',
        dia_pro_forma: '',
        direccion: '',
        factura: '',
    })

    const handleGoBack = () => {
        navigation(`/${routes.billing}`)
    }

    useEffect(() => {
        getInvoiceData().then((response) => {
            const data = response.body.data

            setData({
                rut: formatRut(data.rut),
                correo: data.correoFacturacion,
                nombre: data.razonSocial,
                commission: {
                    presencial: `${Number(data.comisionVenta).toFixed(1)}%`,
                    online: `${Number(data.comisionOnline).toFixed(1)}%`,
                    avance: `${Number(data.comisionAvance).toFixed(1)}%`,
                },
                giro: data.giro,
                recurrencia: data.recurrenciaFactura,
                fecha_contrato: format(
                    new Date(data.fechaContrato),
                    'dd/MM/yyyy'
                ),
                dia_pro_forma: data.diaEmisionProforma,
                direccion: data.direcion,
                factura: String(data.poseeFactura) === 'true' ? 'Si' : 'No',
            })
        })
    }, [])

    return (
        <div className={styles.sectionFacturacionData}>
            <div className={styles.header}>
                <img
                    src={arrowBack}
                    onClick={handleGoBack}
                    className={styles.back}
                />
                <Text
                    fontSize={20}
                    marginLeft={15}
                    color="#656565"
                    fontWeight={600}
                    label="Datos de Facturación"
                />
            </div>
            <div>
                <div className={styles.section}>
                    <div className={styles.item}>
                        <div className={styles.icon}>
                            <SvgIcon iconName="BIconsStore" />
                        </div>
                        <div>
                            <Text
                                label="Rut local"
                                fontSize={14}
                                color="#656565"
                                fontWeight={600}
                            />
                            <Text
                                label={data.rut}
                                fontSize={14}
                                color="#656565"
                                fontWeight={400}
                            />
                        </div>
                    </div>
                    <div className={styles.item}>
                        <div className={styles.icon}>
                            <SvgIcon iconName="BIconsEnvelope" />
                        </div>
                        <div>
                            <Text
                                label="Correo facturación"
                                fontSize={14}
                                color="#656565"
                                fontWeight={600}
                            />
                            <Text
                                label={data.correo}
                                fontSize={14}
                                color="#656565"
                                fontWeight={400}
                            />
                        </div>
                    </div>
                </div>
                <div className={styles.section}>
                    <div className={styles.item}>
                        <div className={styles.icon}>
                            <SvgIcon iconName="BIconsIdCard" />
                        </div>
                        <div>
                            <Text
                                label="Razón Social Local"
                                fontSize={14}
                                color="#656565"
                                fontWeight={600}
                            />
                            <Text
                                label={data.nombre}
                                fontSize={14}
                                color="#656565"
                                fontWeight={400}
                            />
                        </div>
                    </div>
                    <div className={styles.item}>
                        <div className={styles.icon}>
                            <SvgIcon iconName="BIconsDiscount" />
                        </div>
                        <div>
                            <Text
                                label="Comisión"
                                fontSize={14}
                                color="#656565"
                                fontWeight={600}
                            />
                            <ul>
                                <li>
                                    <Text
                                        label={`Presencial: ${data.commission.presencial}`}
                                        fontSize={14}
                                        color="#656565"
                                        fontWeight={400}
                                    />
                                </li>
                                <li>
                                    <Text
                                        label={`Tienda online: ${data.commission.online}`}
                                        fontSize={14}
                                        color="#656565"
                                        fontWeight={400}
                                    />
                                </li>
                                <li>
                                    <Text
                                        label={`Avance: ${data.commission.avance}`}
                                        fontSize={14}
                                        color="#656565"
                                        fontWeight={400}
                                    />
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className={styles.section}>
                    <div className={styles.item}>
                        <div className={styles.icon}>
                            <SvgIcon iconName="BIconsTicketMoney" />
                        </div>
                        <div>
                            <Text
                                label="Giro"
                                fontSize={14}
                                color="#656565"
                                fontWeight={600}
                            />
                            <Text
                                label={data.giro}
                                fontSize={14}
                                color="#656565"
                                fontWeight={400}
                            />
                        </div>
                    </div>
                    <div className={styles.item}>
                        <div className={styles.icon}>
                            <SvgIcon iconName="BIconsCalendarCheck" />
                        </div>
                        <div>
                            <Text
                                label="Recurrencia Factura"
                                fontSize={14}
                                color="#656565"
                                fontWeight={600}
                            />
                            <Text
                                label={data.recurrencia}
                                fontSize={14}
                                color="#656565"
                                fontWeight={400}
                            />
                        </div>
                    </div>
                </div>
                <div className={styles.section}>
                    <div className={styles.item}>
                        <div className={styles.icon}>
                            <SvgIcon iconName="BIconsCalendar" />
                        </div>
                        <div>
                            <Text
                                label="Fecha de contrato"
                                fontSize={14}
                                color="#656565"
                                fontWeight={600}
                            />
                            <Text
                                label={data.fecha_contrato}
                                fontSize={14}
                                color="#656565"
                                fontWeight={400}
                            />
                        </div>
                    </div>
                    <div className={styles.item}>
                        <div className={styles.icon}>
                            <SvgIcon iconName="BIconsCalendar" />
                        </div>
                        <div>
                            <Text
                                label="Día emisión pro-forma"
                                fontSize={14}
                                color="#656565"
                                fontWeight={600}
                            />
                            <Text
                                label={data.dia_pro_forma}
                                fontSize={14}
                                color="#656565"
                                fontWeight={400}
                            />
                        </div>
                    </div>
                </div>
                <div className={styles.section}>
                    <div className={styles.item}>
                        <div className={styles.icon}>
                            <SvgIcon iconName="BIconsBeenHere" />
                        </div>
                        <div>
                            <Text
                                label="Dirección"
                                fontSize={14}
                                color="#656565"
                                fontWeight={600}
                            />
                            <Text
                                label={data.direccion}
                                fontSize={14}
                                color="#656565"
                                fontWeight={400}
                            />
                        </div>
                    </div>
                    <div className={styles.item}>
                        <div className={styles.icon}>
                            <SvgIcon iconName="BIconsTicket" />
                        </div>
                        <div>
                            <Text
                                label="Posee factura"
                                fontSize={14}
                                color="#656565"
                                fontWeight={600}
                            />
                            <Text
                                label={data.factura}
                                fontSize={14}
                                color="#656565"
                                fontWeight={400}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
